window.addEventListener("load", function () {
  let controllers = document.querySelectorAll(".main-controllers .controller");
  controllers.forEach(function (controller) {
    controller.addEventListener("input", function (event) {
      let image = document.querySelector(".productImagePreview");
      image.style.transform = `translate(-50%, -50%) scale(${this.value})`;

      // let imageWidth = image.style.width;
      // let imagHeight = image.height;
      // if (this.classList.contains("width")) {
      //   let width = this.value;
      //   image.style.width = width + "%";
      // }

      // if (this.classList.contains("height")) {
      //   let newHeight = this.value;
      //   image.style.height = newHeight + "px";
      // }
    });
  });

  let controller = document.querySelector(".main-controllers");
  document
    .querySelector(".menu-sub-item")
    .addEventListener("click", function (e) {
      document.querySelectorAll(".super-sub-menu li").forEach(function (li) {
        li.addEventListener("click", function () {
          // controller.setAttribute("style", "top: 300px");
          controller.classList.remove("hidden");
        });
      });
    });

  document.querySelector(".frametype").addEventListener("change", function () {
    // controller.setAttribute("style", "top: 0px");
    controller.classList.add("hidden");
  });
});
